import type { QueryClient } from '@tanstack/vue-query'

type TeamPid = number | string | null | undefined

/** Revenue reading query keys, shared by the pages that read them and the payment import notices that refresh them. */
export const dashboardResultsKey = (teamPid: TeamPid) => ['dashboard-results', teamPid]

export const segmentRevenueKey = (teamPid: TeamPid) => ['segment-revenue', teamPid]

export const campaignRevenueKey = (teamPid: TeamPid) => ['campaign-revenue', teamPid]

/** Every revenue reading of a team, after a payment source connects or its first import finishes. */
export const invalidateRevenueQueries = (client: QueryClient, teamPid: TeamPid) =>
  Promise.all(
    [dashboardResultsKey, segmentRevenueKey, campaignRevenueKey].map((key) =>
      client.invalidateQueries({ queryKey: key(teamPid) })
    )
  )
